// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SahD","left":"styles_left__1RfTI"};